
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["setMillis","init","getMillis"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "68af76ae6abf057af53f.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			